// WebSite.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const WebSite = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    es: "https://www.iberostar.com/es/hoteles/mallorca/iberostar-cala-millor/",
    en: "https://www.iberostar.com/en/hotels/majorca/iberostar-cala-millor/",
    de: "https://www.iberostar.com/de/hotels/mallorca/iberostar-cala-millor/",
  };

  return (
    <>
      <button
        className="full-width-button"
        onClick={() => setShowModal(true)}
      >
        <i className="bi bi-globe-americas icon-space" />
        Web Site
      </button>
      {showModal && (
        <LanguageModal
          title="Web Site"
          icon="bi bi-globe-americas"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default WebSite;
